/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {clearProfilePhotoApp} from '../api'

export const useMutationClearProfilePhotoApp = createReactQueryMutationHook('clearProfilePhotoApp', clearProfilePhotoApp)
